import React, { useEffect, useState, useRef } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { cartState, cartTotalState } from '../../atoms';
import { TextControl, CountryControl, BinaryControl, SelectControl } from '../InputControls';
import './style.css';
import CheckoutForm from './cart';
import styles from './cart.module.css';

const imageLegend = {
  '9798989378036': '../../Series-One/Garden_Front.png',
  '9798990416567': '../../Series-Three/JesseBall_07_Mockup1.webp',
  '9798989378074': '../../Series-Three/CanXue_06_Mockup1.webp',
  '9798989378012': '../../Series-One/Ashbery_Front.png',
  '9798989378005': '../../Series-One/MaxBeckmann_Mockup1.webp',
  '9798990416550': '../../Series-Three/MarioBellatin_08_Mockup1.webp',
  '9798990416529': '../../Series-Two/BoraChung_02_Mockup1.webp',
  '9798989378081': '../../Series-Two/Fanmail_Front.png',
  '9798989378050': '../../Series-One/ReneDaumal_Mockup1.webp',
  '9798989378029': '../../Series-One/DodieBellamy_Mockup1.webp',
  '9798989378043': '../../Series-One/B-w_Front.png',
  '9798990416543': '../../Series-Three/EkaKurniawan_10_Mockup1.png',
  '9798990416505': '../../Series-Two/EnriqueVila-Matas_03_Mockup1.webp',
  '9798990416536': '../../Series-Three/Flanagan_Front.png',
  '9798990416574': '../../Series-Three/GeorgiGospodinov_09_Mockup1.webp',
  '9798989378067': '../../Series-Two/McKenzieWark_01_Mockup1.webp',
  '9798990416512': '../../Series-Two/RaymondPettibonTopp_05_Mockup1.webp',
  '9798989378098': '../../Series-Two/VivekNarayanan_04_Mockup1.webp',
  'hanuman_box_02_fl': '../../Boxsets/Series_2_Multiview_Boxset_Flamingo.png',
  'hanuman_box_02_tb': '../../Boxsets/Series_2_Multiview_Boxset_TabrizBlue.png',
  'hanuman_box_02_nb': '../../Boxsets/Series_2_Multiview_Boxset_NewBlue.png',
  'hanuman_box_02_ct': '../../Boxsets/Series_2_Multiview_Boxset_Citrine.png',
  'hanuman_box_03_mg': '../../Boxsets/midgreen_cart.png',
  'hanuman_box_03_ny': '../../Boxsets/neonyellow_cart.png',
  'hanuman_box_03_pp': '../../Boxsets/purple_cart.png',
  'hanuman_box_03_rs': '../../Boxsets/rose_cart.png',
  '9798995641001': '../../Series-Special/1969_Front_v2.png',
  '9798990416598': '../../Series-Special/Weil_Front.png',
  '9798990416581': '../../Series-Special/Michaux_Front_v2.png',
}

export default function CartPage() {
  const [items, setItems] = useState([]);
  const [email, setEmail] = useState('');
  const [consent, setConsent] = useState(true);
  const [country, setCountry] = useState('');
  const cartTotal = useRecoilValue(cartTotalState);
  const [message, setMessage] = useState('');
  const [checkingOut, setCheckingOut] = useState(false);
  const [fetchingRates, setFetchingRates] = useState(false);
  const [rates, setRates] = useState([]);
  const [errorFields, setErrorFields] = useState([]);

  const [cart, setCart] = useRecoilState(cartState);

  document.title = `Cart | Hanuman Editions`;
  document.querySelector('meta[name="description"]').setAttribute('content', `Checkout to complete your order.`);

  const debounceDelay = 750;
  const debounceTimer = useRef(0);
  const controller = useRef();

  const getRates = async () => {
    let ounces = 0;
    items.forEach((item) => {
      ounces += item.weight * item.count;
    });
    if (!country || !ounces) {
      setRates([]);
      setFetchingRates(false);
      return;
    }
    setFetchingRates(true);
    let request = {
      ounces: ounces,
      country: country,
      postalCode: null,
      express: false,
      free: false,
      items: 1,
      noPacking: true,
      value: 20,
    }
    let rates = await fetch('https://asterismbooks.com/api/new-shipping-rates', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });
    let data = await rates.json();
    if (data) {
      let delay = getDateDelay();
      data = data.map((rate) => {
        rate.delivery_days += delay;
        return rate;
      })
      setRates(data)
    }
    setFetchingRates(false);
  }

  const updateShipping = async () => {
    clearTimeout(debounceTimer.current);
    controller.current?.abort();
    controller.current = new AbortController();
    debounceTimer.current = setTimeout(async () => {
      getRates();
    }, debounceDelay);

  }

  useEffect(() => {
    updateShipping();
  }, [items, country]);


  useEffect(() => {
    setItems(Object.values(cart));
  }, [cart]);

  const changeQuantity = (id, no) => {
    let newCart = { ...cart };
    let newItem = { ...cart[id] };
    newItem.count = newItem.count += no;
    newCart[id] = newItem;
    setCart(newCart);
  }

  const removeItem = (id) => {
    let newCart = { ...cart };
    delete newCart[id];
    setCart(newCart);
  }

  const getDateDelay = () => {
    let day = new Date().getDay();
    return day === 5 ? 4 : day === 6 ? 3 : day === 0 ? 2 : 1;
  }

  const checkout = async () => {
    setMessage('');
    if (!email) {
      setErrorFields(['email']);
      setMessage('Please enter a valid email');
      return;
    } else if (!country) {
      setErrorFields(['country']);
      setMessage('Please select a country for shipping');
      return;
    }
    setCheckingOut(true);
  }

  return (
    <div className='newPageContainer'>
      <div className={styles.cartContainer}>
        <h1>Your Order</h1>
        <div className={styles.cartItems}>
          <div className={styles.cartItemHeader}>
            <div className={styles.headerImage}></div>
            <div className={styles.headerLabel}>Title</div>
            <div className={styles.headerLabel}>Quantity</div>
            <div className={styles.headerLabel}>Price</div>
            <div className={styles.headerLabel}>Total</div>
          </div>
          {items.map((item) =>
            <div className={styles.cartItem} key={item.id}>
              <div className={styles.cartImage} style={{
                backgroundImage: `url(${imageLegend[item.id] ? imageLegend[item.id] : item.image})`
              }}>

              </div>
              <div className={styles.cartDetails}>
                <div>
                  <div className={styles.cartItemTitle}>{item.title}</div>
                  <div className={styles.cartItemAuthor}>{item.author}</div>
                </div>
                <button className={styles.cartRemove} onClick={() => removeItem(item.id)}>Remove</button>
              </div>
              <div className={styles.cartCell}>
                {item.count}
              </div>
              <div className={styles.cartCell}>
                ${item.price}
              </div>
              <div className={styles.cartCell}>
                ${(item.price * item.count).toFixed(2)}
              </div>
            </div>
          )}
          <div className={styles.cartSubtotal}>
            <div className={styles.headerImage}></div>
            <div className={styles.headerLabel}></div>
            <div className={styles.headerLabel}></div>
            <div className={styles.cartCell}>Subtotal</div>
            <div className={styles.cartCell}>${(cartTotal).toFixed(2)}</div>
          </div>
        </div>

        {items.length === 0 ? <div>There is nothing in your cart</div> :
          <>

          </>
        }

        <TextControl
          placeholder={'Email Address'}
          value={email}
          change={setEmail}
        />
        <div>
          <div className={styles.binaryLabel}>Please keep me updated on future publications and announcements</div>
          <BinaryControl
            label=''
            value={consent}
            change={setConsent}
            options={['Yes', 'No']}
          />
        </div>


        <CountryControl
          value={country}
          placeholder={'Select a shipping country'}
          change={setCountry}
        />
        {message && <div className={styles.cartError}>{message}</div>}
        <button disabled={items.length === 0 || fetchingRates} className={styles.checkoutButton} onClick={checkout}>{fetchingRates ? <span className={styles.checkOutLabel}><LoadingSpinner /> Preparing Shipping Options</span> : 'Checkout'}</button>
        {checkingOut && <CheckoutForm cart={cart} rates={rates} close={() => { setCheckingOut(false) }} country={country} email={email} consent={consent} />}

      </div>
    </div>
  )
}

function LoadingSpinner() {
  return (
    <svg fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M10.72,19.9a8,8,0,0,1-6.5-9.79A7.77,7.77,0,0,1,10.4,4.16a8,8,0,0,1,9.49,6.52A1.54,1.54,0,0,0,21.38,12h.13a1.37,1.37,0,0,0,1.38-1.54,11,11,0,1,0-12.7,12.39A1.54,1.54,0,0,0,12,21.34h0A1.47,1.47,0,0,0,10.72,19.9Z"><animateTransform attributeName="transform" type="rotate" dur="0.75s" values="0 12 12;360 12 12" repeatCount="indefinite"></animateTransform></path></svg>
  )
}